import { defineSlotRecipe } from '@chakra-ui/react'

// Table: header background -> surface.2 (lets ResponsiveTable drop its inline
// `bg="gray.50"` literal, Task 9), hairline `border` on cells, `surface.2`
// row hover, and comfortable 40px / compact 32px row height applied at BOTH
// the `sm` and `md` size steps (Global Constraints line 21 — mirrors
// Button/Input/NativeSelect's sm+md density fix; the app renders
// `<Table.Root size="sm">` almost everywhere, so `sm` is the size step that
// actually matters at runtime).
//
// Row height lands on the `row` slot (`<tr>`), not `cell`/`columnHeader`
// (`<td>`/`<th>`). Chakra's Table.Row component (table.js) is the SAME "tr"
// styled-context for both `Table.Header > Table.Row` and
// `Table.Body > Table.Row` (confirmed in ResponsiveTable.tsx, which reuses
// `<Table.Row>` for the header row and every body row) — so a height on
// `row` covers header + body rows uniformly, where a height on `cell` alone
// would leave the header row's `<th>`s ungoverned.
//
// Base-vs-variant defeat check (the gotcha that cost two fix rounds on
// Tasks 2-3): the stock v3.36 table recipe's `variants.size.{sm,md,lg}` only
// sets `px`/`py` padding on `columnHeader`/`cell` and `textStyle` on `root` —
// it never sets `row.h`/`row.minH`, so there is no competing default variant
// on this slot/property to lose to. The override still lives under
// `variants.size.sm`/`.md` (not `base`) to match the plan's explicit "applied
// at BOTH the sm and md size steps" requirement and to leave `lg` alone, the
// same shape Button/Input/NativeSelect already use.
//
// `_compact` (not the bare `compact` declared in conditions.ts) is required
// for the density condition to apply — see button.recipe.ts for the full
// v3.36 remap explanation.
const densityH = { h: '2.5rem', minH: '2.5rem', _compact: { h: '2rem', minH: '2rem' } }

export const tableSlotRecipe = defineSlotRecipe({
  slots: ['root', 'header', 'body', 'row', 'columnHeader', 'cell'],
  base: {
    columnHeader: {
      bg: 'surface.2',
      color: 'muted',
      borderColor: 'border',
      fontWeight: 600,
    },
    cell: { borderColor: 'border' },
    row: { _hover: { bg: 'surface.2' } },
  },
  variants: {
    size: {
      sm: { row: densityH },
      md: { row: densityH },
    },
  },
})
